(function () {
  if (window.CdlBoostCardCanonicalInitialized) return;
  window.CdlBoostCardCanonicalInitialized = true;

  const GENERIC_VENDOR = /^planeta de libros argentina$/i;

  function splitTitleAndAuthor(title) {
    const cleanTitle = String(title || '')
      .replace(/ - Impresi[oó]n a demanda$/i, '')
      .trim();
    const separatorIndex = cleanTitle.lastIndexOf(' - ');

    if (separatorIndex < 1) {
      return { title: cleanTitle, author: '' };
    }

    return {
      title: cleanTitle.slice(0, separatorIndex).trim(),
      author: cleanTitle.slice(separatorIndex + 3).trim()
    };
  }

  function normalizeText(card, bottom) {
    const title = bottom.querySelector('.boost-pfs-filter-product-item-title');
    const vendor = bottom.querySelector('.boost-pfs-filter-product-item-vendor');
    const price = bottom.querySelector('.boost-pfs-filter-product-item-price');

    if (title) {
      title.classList.add('cdl-listing-title');
      if (!title.dataset.cdlOriginalTitle) {
        title.dataset.cdlOriginalTitle = title.textContent.trim();
      }

      const productText = splitTitleAndAuthor(title.dataset.cdlOriginalTitle);
      title.textContent = productText.title;

      if (vendor) {
        vendor.classList.add('cdl-listing-author');
        const currentVendor = vendor.textContent.trim();
        if (productText.author) {
          vendor.textContent = productText.author;
        } else if (GENERIC_VENDOR.test(currentVendor)) {
          vendor.textContent = '';
        }
      }
    }

    if (price) price.classList.add('cdl-listing-price');
  }

  function normalizeImages(card) {
    card.querySelectorAll(
      '.boost-pfs-filter-product-item-main-image, .boost-pfs-filter-product-item-flip-image'
    ).forEach(function (image) {
      image.setAttribute('data-auto-trim-image', '');
    });
  }

  function normalizeAction(card, bottom) {
    const action = card.querySelector('.boost-pfs-action-list-wrapper');
    if (!action) return;

    if (bottom.lastElementChild !== action) bottom.appendChild(action);

    const button = action.querySelector('.boost-pfs-addtocart-btn');
    if (!button) return;

    button.classList.add('cdl-listing-cta');
    const label = card.classList.contains('sold-out') || button.disabled
      ? 'Agotado'
      : 'Añadir al carrito';

    // Boost necesita un <span> directo en el botón: sin él, onClickAddToCart
    // falla antes de llamar a cart/add.js.
    if (button.dataset.cdlCtaLabel !== label) {
      const text = document.createElement('span');
      text.textContent = label;
      button.replaceChildren(text);
      button.dataset.cdlCtaLabel = label;
    }
  }

  function normalizeCard(card) {
    if (!card) return;

    const bottom = card.querySelector(
      '.boost-pfs-filter-product-bottom-inner, ' +
      '.boost-pfs-filter-product-item-list-col-2, ' +
      '.boost-pfs-filter-product-bottom'
    );
    if (!bottom) return;

    card.classList.add('cdl-listing-card');
    bottom.classList.add('cdl-listing-info');
    normalizeText(card, bottom);
    normalizeImages(card);
    normalizeAction(card, bottom);
  }

  function scan(root) {
    if (!root || root.nodeType !== 1) return;

    if (root.matches('.boost-pfs-filter-product-item')) normalizeCard(root);
    root.querySelectorAll('.boost-pfs-filter-product-item').forEach(normalizeCard);

    const parentCard = root.closest('.boost-pfs-filter-product-item');
    if (parentCard) normalizeCard(parentCard);
  }

  function initialize() {
    scan(document.body);

    const observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        mutation.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) scan(node);
        });
      });
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
